import get from "lodash/get"
import find from "lodash/find"

export const getLocalizedString = (localizedStrings, codename, fallback) => {
  const node = find(localizedStrings, node => node?.system?.codename === codename)
  const localizedString = get(node, 'elements.localized_string_value.value') || fallback

  return localizedString
}

export default getLocalizedString